export enum TipoSlot {
  estaEntre = 'Está entre',
  naoEstaEntre = 'Não está entre',
  eIgualA = 'É igual a',
  eDiferenteDe = 'É diferente de',
  eMaiorDoQue = 'É maior do que',
  eMenorDoQue = 'É menor do que'
}
